<template>
  <v-app>
    <v-content>
		<ManitzMain/>
    </v-content>
  </v-app>
</template>

<script>
import ManitzMain from "./components/ManitzMain.vue"

export default {
  name: 'App',

  components: {
		ManitzMain,
  },

  data: () => ({
    //
  }),
};
</script>

<style>
div.theme--light.v-application {
    background-attachment: fixed;
    background-repeat: repeat;
    background-image: linear-gradient(135deg,#082030 0,#4d7384 58%);
    background-image: -webkit-linear-gradient(315deg,#082030 0,#4d7384 58%);
    background-image: -o-linear-gradient(315deg,#082030 0,#4d7384 58%);
    background-image: -ms-linear-gradient(315deg,#082030 0,#4d7384 58%);
    background-image: -moz-linear-gradient(315deg,#082030 0,#4d7384 58%);
    background-position: center center;
}
.theme--light.v-app-bar.v-toolbar.v-sheet {
	background-color: inherit;
	/* border-bottom: 1px solid lightgray; */
}
.v-application {
	font-family: 'Droid Sans',Arial,'Arial Unicode MS',Helvetica,sans-serif !important;
	font-weight: 500
}
.v-application p {
    margin-bottom: 16px;
    margin-top: 16px;
}
.v-banner .v-banner__wrapper {
	padding: 0px;
	background-color: white;
}
blockquote {
    /* padding: 0.5625rem 1.25rem 0 1.1875rem; */
    padding: 0.125rem 1.25rem 0 1.1875rem;
    border-left: 2px solid #ddd;
}
</style>
